import { h } from 'preact';
import { useToast } from '../Toast';
import { Button } from '../Button';
import type { ComponentShowcase } from '../registry';

function ToastShowcaseWrapper() {
  const toast = useToast();
  return (
    <div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Button variant="ghost" onClick={() => toast.show('Operação realizada com sucesso!', 'success')}>✓ Success</Button>
        <Button variant="ghost" onClick={() => toast.show('Erro ao processar. Tente novamente.', 'error')}>✕ Error</Button>
        <Button variant="ghost" onClick={() => toast.show('Atenção: limite próximo do máximo.', 'warning')}>⚠ Warning</Button>
        <Button variant="ghost" onClick={() => toast.show('Nova versão disponível.', 'info')}>ℹ Info</Button>
      </div>
      <toast.ToastContainer />
    </div>
  );
}

export const showcase: ComponentShowcase = {
  name: 'Toast',
  category: '🪟 Modais & Overlay',
  description: 'Notificações toast com 4 tipos (success, error, warning, info) e auto-dismiss',
  usedIn: ['AgentesPage', 'Integrations', 'Profile'],
  example: () => <ToastShowcaseWrapper />,
};
